import axios from 'axios';
import { API_BASE_URL } from './config';

axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const httpClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

httpClient.defaults.xsrfCookieName = 'XSRF-TOKEN';
httpClient.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

export default httpClient;
